import Dashboard from '../containers/dashboard'
import CustomerCompanyDetailsManagement from '../containers/customer-company-details-management'

const CustomerCompanyDetails = () => {
  return (
    <Dashboard>
      <CustomerCompanyDetailsManagement />
    </Dashboard>
  )
}

export default CustomerCompanyDetails
